import React from 'react';
import styled from 'styled-components';
import Selector from '../../../../../UserProfileSelector';
import { LOCATION_SOURCE_CDP } from '../../../../../../constants';

const StyledUserProfileSelector = styled(Selector).withConfig({ componentId: 'sc-1qckd7v-0' })`
  margin-top: 10px;
`;

type Props = {
  accountSummary?: any;
  handleChangeUserProfile: (...args: any[]) => any;
  visible?: boolean;
};

const UserProfileSelector = ({ accountSummary, handleChangeUserProfile, visible }: Props) => {
  if (!visible) return null;

  return (
    <StyledUserProfileSelector
      accountSummary={accountSummary}
      handleChangeUserProfile={handleChangeUserProfile}
      source={LOCATION_SOURCE_CDP}
    />
  );
};

export default UserProfileSelector;
